import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { User } from '../../types/User';
import authService from '../../services/authService';

// Adjust the path if necessary

interface UserState {
  user: User | null;
  status: 'idle' | 'loading' | 'succeeded'  | 'failed';
  error: string | undefined;
}

const initialState: UserState = {
  user: null,
  status: 'idle',
  error: undefined,
};

export const loginUser = createAsyncThunk<
  User,
  { username: string; password: string; navigate: (path: string) => void },
  {}
>('user/loginUser', async ({ username, password, navigate }, thunkAPI) => {
  try {
    const authUser = await authService.login({ username, password });
    console.log(authUser)
    
    // Map AuthUser to User type
    const user: User = {
      userId: authUser.id,
      userName: authUser.username,
      email: authUser.email,
      roleId: 1, // Default role ID
      groupId: 1, // Default group ID
    };
    
    navigate('/');  // navigating to home page on successful login
    return user;
  } catch (error) {
    return thunkAPI.rejectWithValue((error as Error).message);
  }
});

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    logoutUser: (state) => {
      state.user = null;
      state.status = 'idle';  // Reset status as well
      state.error = undefined;  // Reset error state as well
      localStorage.removeItem('user');
      localStorage.removeItem('token');
    },
  },
  
  extraReducers: (builder) => {
    builder
      .addCase(loginUser.pending, (state) => {
        state.status = 'loading';
        state.error = undefined;
      })
      .addCase(loginUser.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.user = action.payload;
      })
      .addCase(loginUser.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message;
      });
  },
});

export const { logoutUser } = userSlice.actions;

export default userSlice.reducer;
